export default __webpack_public_path__ + "static/media/ryan_c.cab57d7a.png";